import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const ADD_CATEGORY = 'category/ADD';
export const addCategory = createAction(
  ADD_CATEGORY,
  payload => payload,
  (_payload, meta) => meta,
);
